import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=464bbf68&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"
import style0 from "./Categories.vue?vue&type=style&index=0&id=464bbf68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bbf68",
  null
  
)

export default component.exports